import {
  Card,
  CardContent,
  Grid,
  TextField,
  Typography,
  makeStyles,
} from "@material-ui/core";

import React, { useEffect, useState } from "react";
import { fetchPortAuthoritiesForExternalUser } from "../../../services/portAuthoritiesService";
import { fetchPrfcsForExternalUser } from "../../../services/prfcsService";
import { fetchSectors } from "../../../services/sectorService";
import useLocale from "../../../hooks/useLocale";
// import { useQuery } from "react-query";
import GovGrButton from "../../../components/GovGrButton";
import {
  ABROAD_BIRTH_PLACE_ID,
  educationLevel,
  GR_CODE_CRIMINAL,
  ISSUE_COPY_NAUTICAL,
  NEW_NAUTICAL_APPLICATION,
  retiredOptions,
} from "../../../constants";
import { portAuthoritySort } from "../../../utils/portAuthoritySort";
import GovGrCard from "../../../components/GovGrCard";
import GovGrTextField from "../../../components/GovGrTextField";
import GovGrSelectBox from "../../../components/GovGrSelectBox";
import GovGrDate from "../../../components/GovGrDate";
import CheckBoxesForCustomText from "../../external user/new application/CheckBoxesForCustomText";
import { fetchBirthCountry } from "../../../services/birthCountryService";
import { useField } from "formik";
import { useMutation, useQuery } from "react-query";
import {
  fetchApplicationWithId,
  updateApplicationStatusAndHistory,
  updateApplicationPortAuth,
} from "../../../services/applicationsService";

const useStyles = makeStyles({
  root: {
    "& .MuiTextField-root": {
      margin: 15,
    },
    "& .MuiInputBase-root.Mui-disabled": {
      color: "rgba(0, 0, 0, 1)", // (default alpha is 0.38)
    },
  },
  card: {
    minWidth: 275,
    marginTop: 15,
    marginBottom: 15,
    alignSelf: "center",
  },
  autoComplete: {
    width: 225,
    // maxWidth: 221,
    display: "inline-block",
    marginRight: "30px",
  },
});

const ApplicantDetails = ({
  setFieldValue,
  errors,
  touched,
  rid,
  values,
  currentStatus,
  disableAll,
  translatedGender,
  updateportauth,
}) => {
  const { t } = useLocale();
  const classes = useStyles();
  const { data: prfcsData } = useQuery("prfcs", fetchPrfcsForExternalUser);
  const { data: sectors } = useQuery("sectors", fetchSectors);
  const { data: portAuthorities } = useQuery(
    "portAuthorities",
    fetchPortAuthoritiesForExternalUser
  );
  const portField = useField("portAuthorityApplicant");
  const [portid, setPortid] = useState(portField?.[0]?.value?.id);
  const [portfieldenable, setPortfieldenable] = useState(false);

  const TranslatedRetiredOptions = retiredOptions?.map((option) => ({
    ...option,
    dscr: t(`${option.dscr}`),
  }));

  const TranslatedEducationLevel = educationLevel?.map((option) => ({
    ...option,
    dscr: t(`${option.dscr}`),
  }));

  //Check if the application is New Nautical and return true or false to hide the extra fields
  const checkIfThisApplicationIsNewIssuing = () => {
    if (parseInt(values?.appl_kind_id) === parseInt(NEW_NAUTICAL_APPLICATION)) {
      return true;
    } else {
      return false;
    }
  };

  const { data: fetchBirthCountries } = useQuery(
    "fetchBirthCountries",
    fetchBirthCountry
  );
  // Get portAuthorities Sorted via requirements (sort them by City with 1st DNER)
  const portAuthoritiesSorted = portAuthoritySort(portAuthorities);
  // // Check if the application is New Nautical and return true or false to hide the extra fields
  // const checkNewNautical = () => {
  //   if (
  //     parseInt(props?.applicationKindId) === parseInt(NEW_NAUTICAL_APPLICATION)
  //   ) {
  //     return true;
  //   } else {
  //     return false;
  //   }
  // };

  // //Check if the application is Copy of Nautical and return true or false to hide the extra fields

  const checkCopyNauticalApplication = () => {
    if (parseInt(values?.appl_kind_id) === parseInt(ISSUE_COPY_NAUTICAL)) {
      return true;
    } else {
      return false;
    }
  };
  const { data: PortAuthoritiesData } = useQuery(
    "portAuthorities",
    fetchPortAuthoritiesForExternalUser
  );




  const { mutate } = useMutation(updateApplicationPortAuth, {
    onSuccess: (data, values, setFieldValues) => {
      // console.log(data);
      updateportauth();
      setPortfieldenable(false);
      // const objWithStatus = JSON.parse(values?.items);
      // refetchApplication();
      // refetchApplicationHistory();
      // setError("");
      // setSuccess(t("Application status changed successfully"));
      // setTimeout(() => {
      //   setSuccess("");
      //   let currentStatus = applicationStatus?.find(
      //     (status) => status.id === objWithStatus[0].application.status
      //   );

      //   if (
      //     currentStatus.is_service === CLIENT_SIDE ||
      //     currentStatus.is_service === NOONE_SIDE
      //   ) {
      //     history.push("/editApplications");
      //   }
      // }, 3000);
    },
    onError: (error, values) => {
      // console.log(error);
      updateportauth();
      // switch (error) {
      //   default: {
      //     setError(t(error.response.data));
      //     const items = JSON.parse(values.items);
      //     // if there was an error in rejection reset medical a fields
      //     if (
      //       items[0].applicationHistory.new_status ===
      //       MEDICAL_A_DEGREE_REJECTION
      //     ) {
      //       formikRef.current.setFieldValue("a_medical_date", null);
      //       formikRef.current.setFieldValue("history_comment", "");
      //     }
      //   }
      // }

    }
  });

  const updateportauth_ = async (values) => {
    const valuesToSend = {
      application: {
        id: rid,
        port_authority_id: values.port_authority_id,
      },

      // applicationHistory: {
      //   appl_id: id,
      //   // port_authority_id: values.currentStatus,
      // },
    };
    // console.log(valuesToSend);
    // updateApplicationPortAuth(JSON.stringify([valuesToSend]))
    mutate({ items: JSON.stringify([valuesToSend]) });
    // console.log("updateportauth")
  }


  const updateportauthL = (port_authority_id) => {
    values.port_authority_id = port_authority_id;
    // values.id = port_authority_id;
    updateportauth_(values);

  }

  useEffect(() => {

    if (PortAuthoritiesData) {
      const portAuth = PortAuthoritiesData?.find(
        (p) => p.id == portField?.[0]?.value?.id
      );
      portField[2].setValue(portAuth);
    }
    // console.log("values " + rid);
    // console.log(values.id);

    if (portid !== portField?.[0]?.value?.id) {
      // console.log("change " + portField?.[0]?.value?.id);
      setPortfieldenable(true);
    }

    setPortid(portField?.[0]?.value?.id);

  }, [portField?.[0].value]);

  return (
    <>
      <div className={classes.root}>
        <GovGrCard>
          <Typography variant="h3" color="textSecondary" gutterBottom>
            {t("Application Details")}
          </Typography>
          <Grid container spacing={5}>
            <Grid item xs={12} sm={12} md={6} lg={6} xl={4}>
              <GovGrTextField
                variant="outlined"
                name="applicationKind"
                margin="normal"
                disabled
                label={t("Application Kind")}
                className="mr-5"
              />
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6} xl={4}>
              <GovGrSelectBox
                disabled={false} //{disableAll}
                // disabled={disableAll}
                name="portAuthorityApplicant"
                label={t("Port Authority")}
                options={portAuthoritiesSorted || []}
                optionlabel="dscr"
                defaultoptiontext={t("Choose Here")}
                disabledmessage={t("Field can't be edited")}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6} xl={4}>
              <GovGrTextField
                variant="outlined"
                name="appl_dt"
                margin="normal"
                disabled
                label={t("Application Date")}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6} xl={4}>
              <GovGrTextField
                variant="outlined"
                name="reg_num"
                margin="normal"
                disabled
                label={t("Protocol Number")}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6} xl={4}>
              <GovGrSelectBox
                disabled={disableAll}
                name="sector"
                label={t("Sector")}
                options={sectors || []}
                optionlabel="dscr"
                defaultoptiontext={t("Choose Here")}
                disabledmessage={t("Field can't be edited")}
              />
            </Grid>

            <Grid item xs={12} sm={12} md={6} lg={6} xl={4}>
              <div className={classes.buttonArea}>
                <GovGrButton
                  disabled={!portfieldenable}
                  onClick={() => {
                    updateportauthL(portid);
                  }}
                  fullWidth
                  variant="primary"
                  buttonText={t("Submit")}
                />
              </div>
            </Grid>
          </Grid>
        </GovGrCard>
        <GovGrCard>
          <Typography variant="h3" color="textSecondary" gutterBottom>
            {t("Pickup place")}
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={6} lg={6} xl={4}>
              <GovGrSelectBox
                // disabled={false} //{disableAll}
                disabled={disableAll}
                name="pickup_place"
                label={t("Port Authority")}
                options={PortAuthoritiesData || []}
                optionlabel="dscr"
                initialvalue={
                  values?.pickup_place_id || values?.pickup_place?.id
                }
                defaultoptiontext={t("Choose Here")}
                disabledmessage={t("Field can't be edited")}
              />
            </Grid>
          </Grid>
        </GovGrCard>
        {values?.afm_ait !== values?.afm_afora ? (
          <GovGrCard>
            <Typography variant="h3" color="textSecondary" gutterBottom>
              {t("Applicant details")}
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12} md={6} lg={6} xl={4}>
                <GovGrTextField
                  variant="outlined"
                  name="lname_ait"
                  margin="normal"
                  disabled={disableAll}
                  label={t("Surname")}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={6} xl={4}>
                <GovGrTextField
                  variant="outlined"
                  name="fname_ait"
                  margin="normal"
                  disabled={disableAll}
                  label={t("Name")}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={6} xl={4}>
                <GovGrTextField
                  variant="outlined"
                  name="afm_ait"
                  margin="normal"
                  disabled={disableAll}
                  label={t("AFM")}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={6} xl={4}>
                <GovGrTextField
                  variant="outlined"
                  name="ind_nr_ait"
                  margin="normal"
                  disabled={disableAll}
                  label={t("ADT")}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={6} xl={4}>
                <GovGrTextField
                  variant="outlined"
                  name="amka_ait"
                  margin="normal"
                  disabled={disableAll}
                  label={t("AMKA")}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={6} xl={4}>
                <GovGrTextField
                  variant="outlined"
                  name="meth_ait"
                  margin="normal"
                  disabled={disableAll}
                  label={t("Meth")}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={6} xl={4}>
                <GovGrTextField
                  variant="outlined"
                  name="fath_lname_ait"
                  margin="normal"
                  disabled={disableAll}
                  label={t("Father Surname")}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={6} xl={4}>
                <GovGrTextField
                  variant="outlined"
                  name="fath_fname_ait"
                  margin="normal"
                  disabled={disableAll}
                  label={t("Father Name")}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={6} xl={4}>
                <GovGrTextField
                  variant="outlined"
                  name="address_ait"
                  margin="normal"
                  disabled={disableAll}
                  label={t("Address")}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={6} xl={4}>
                <GovGrTextField
                  variant="outlined"
                  name="address_nr_ait"
                  margin="normal"
                  disabled={disableAll}
                  label={t("Address Number")}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={6} xl={4}>
                <GovGrTextField
                  variant="outlined"
                  name="tk_ait"
                  margin="normal"
                  disabled={disableAll}
                  label={t("TK")}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={6} xl={4}>
                <GovGrTextField
                  variant="outlined"
                  name="tel_ait"
                  margin="normal"
                  disabled={disableAll}
                  label={t("Phone Number")}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={6} xl={4}>
                <GovGrTextField
                  variant="outlined"
                  name="mobile_ait"
                  margin="normal"
                  disabled={disableAll}
                  label={t("Mobile Phone Number")}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={6} xl={4}>
                <GovGrTextField
                  variant="outlined"
                  name="email_ait"
                  margin="normal"
                  disabled={disableAll}
                  label={t("Email")}
                />
              </Grid>
            </Grid>
          </GovGrCard>
        ) : null}
        <GovGrCard>
          <Typography variant="h3" color="textSecondary" gutterBottom>
            {t("Applicant details concerning")}
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={6} lg={6} xl={4}>
              <GovGrTextField
                variant="outlined"
                name="lname_afora"
                margin="normal"
                disabled={disableAll}
                label={t("Surname")}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6} xl={4}>
              <GovGrTextField
                variant="outlined"
                name="fname_afora"
                margin="normal"
                disabled={disableAll}
                label={t("Name")}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6} xl={4}>
              <GovGrTextField
                variant="outlined"
                name="afm_afora"
                margin="normal"
                disabled={disableAll}
                label={t("AFM")}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6} xl={4}>
              <GovGrSelectBox
                disabled={disableAll}
                name="gender_afora"
                label={t("Gender")}
                options={translatedGender || []}
                optionlabel="dscr"
                defaultoptiontext={t("Choose Here")}
                disabledmessage={t("Field can't be edited")}
              />
            </Grid>

            <Grid item xs={12} sm={12} md={6} lg={6} xl={4}>
              <GovGrTextField
                required
                variant="outlined"
                name="nationality_afora"
                margin="normal"
                label={t("Nationality")}
                disabled={disableAll}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6} xl={4}>
              <GovGrTextField
                variant="outlined"
                name="ind_nr_afora"
                margin="normal"
                disabled={disableAll}
                label={t("ADT")}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6} xl={4}>
              <GovGrTextField
                variant="outlined"
                name="amka_afora"
                margin="normal"
                disabled={disableAll}
                label={t("AMKA")}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6} xl={4}>
              <GovGrTextField
                variant="outlined"
                name="meth_afora"
                margin="normal"
                disabled={disableAll}
                label={t("Meth")}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6} xl={4}>
              <GovGrTextField
                variant="outlined"
                name="fath_lname_afora"
                margin="normal"
                disabled={disableAll}
                label={t("Father Surname")}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6} xl={4}>
              <GovGrTextField
                variant="outlined"
                name="fath_fname_afora"
                margin="normal"
                disabled={disableAll}
                label={t("Father Name")}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6} xl={4}>
              <GovGrTextField
                variant="outlined"
                name="moth_lname_afora"
                margin="normal"
                disabled={disableAll}
                label={t("Mother Surname")}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6} xl={4}>
              <GovGrTextField
                variant="outlined"
                name="moth_fname_afora"
                margin="normal"
                disabled={disableAll}
                label={t("Mother Name")}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6} xl={4}>
              <GovGrTextField
                variant="outlined"
                name="address_afora"
                margin="normal"
                disabled={disableAll}
                label={t("Address")}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6} xl={4}>
              <GovGrTextField
                variant="outlined"
                name="address_nr_afora"
                margin="normal"
                disabled={disableAll}
                label={t("Address Number")}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6} xl={4}>
              <GovGrTextField
                variant="outlined"
                name="tk_afora"
                margin="normal"
                disabled={disableAll}
                label={t("TK")}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6} xl={4}>
              <GovGrTextField
                variant="outlined"
                name="tel_afora"
                margin="normal"
                disabled={disableAll}
                label={t("Phone Number")}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6} xl={4}>
              <GovGrTextField
                variant="outlined"
                name="mobile_afora"
                margin="normal"
                disabled={disableAll}
                label={t("Mobile Phone Number")}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6} xl={4}>
              <GovGrTextField
                variant="outlined"
                name="email_afora"
                margin="normal"
                disabled={disableAll}
                label={t("Email")}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6} xl={4}>
              <GovGrDate
                required
                name="dt_birth_afora"
                label={t("Date of birth")}
                disabled={disableAll}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6} xl={4}>
              <GovGrSelectBox
                disabled={disableAll}
                name="birth_country"
                label={t("Birth Country")}
                options={fetchBirthCountries || []}
                optionlabel="dscr"
                defaultoptiontext={t("Choose Here")}
                disabledmessage={t("Field can't be edited")}
              />
            </Grid>

            {values?.birth_country?.id !== GR_CODE_CRIMINAL && (
              <Grid item xs={12} sm={12} md={6} lg={6} xl={4}>
                <GovGrTextField
                  required
                  name="birth_city_not_greece"
                  margin="normal"
                  label={t("Birth City Abroad")}
                  disabled={disableAll}
                  disabledmessage={t("Field can't be edited")}
                />
              </Grid>
            )}
            <Grid item xs={12} sm={12} md={6} lg={6} xl={4}>
              <GovGrSelectBox
                disabled={disableAll}
                name="place_birth_afora"
                label={t("Place of birth")}
                options={
                  prfcsData?.sort((a, b) => (b.dscr < a.dscr ? 1 : -1)) || []
                }
                initialvalue={values?.place_birth_afora}
                optionlabel="dscr"
                defaultoptiontext={t("Choose Here")}
                disabledmessage={t("Field can't be edited")}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6} xl={4}>
              <GovGrSelectBox
                disabled={disableAll}
                name="dimos_diamonis_afora"
                label={t("Place of staying")}
                options={
                  prfcsData?.sort((a, b) => (b.dscr < a.dscr ? 1 : -1)) || []
                }
                initialvalue={values?.dimos_diamonis_afora}
                optionlabel="dscr"
                defaultoptiontext={t("Choose Here")}
                disabledmessage={t("Field can't be edited")}
              />
            </Grid>
            {(values?.place_birth_afora?.id === ABROAD_BIRTH_PLACE_ID ||
              values?.place_birth_afora === ABROAD_BIRTH_PLACE_ID) && (
                <Grid item xs={12} sm={12} md={6} lg={6} xl={4}>
                  <GovGrTextField
                    required
                    variant="outlined"
                    name="topos_eggrafis_dimotologiou_ellada"
                    margin="normal"
                    label={t("Place of registration in Greece")}
                    disabled={disableAll}
                  />
                </Grid>
              )}

            {checkIfThisApplicationIsNewIssuing() && (
              <>
                <Grid item xs={12} sm={12} md={6} lg={6} xl={4}>
                  <GovGrSelectBox
                    disabled={disableAll}
                    name="epipedo_ekpaideusis_afora"
                    label={t("Education level")}
                    options={TranslatedEducationLevel || []}
                    optionlabel="dscr"
                    defaultoptiontext={t("Choose Here")}
                    disabledmessage={t("Field can't be edited")}
                  />
                </Grid>
              </>
            )}
          </Grid>
          <CheckBoxesForCustomText
            applicationId={values?.appl_kind_id}
            disableAll={disableAll}
          />
        </GovGrCard>
      </div>
    </>
  );
};

export default ApplicantDetails;
